/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum UnscheduledReasonCode {
  CONSTRAINTS_MISMATCH="CONSTRAINTS_MISMATCH",
TAG_MISMATCH="TAG_MISMATCH",
TIME_WINDOW_SHORTER_THAN_DURATION="TIME_WINDOW_SHORTER_THAN_DURATION",
OUT_OF_REGION="OUT_OF_REGION",
GEOCODING_FAILED="GEOCODING_FAILED"
}

/**
* UnscheduledReasonCode
 *
 * Why the engine left an order unscheduled. Absent when the reason cannot be classified.
*/
export const UnscheduledReasonCodeEnumType = types.enumeration("UnscheduledReasonCode", [
        "CONSTRAINTS_MISMATCH",
  "TAG_MISMATCH",
  "TIME_WINDOW_SHORTER_THAN_DURATION",
  "OUT_OF_REGION",
  "GEOCODING_FAILED",
      ])
